import { render } from "./SectionFeedback.vue?vue&type=template&id=6c79f25a&scoped=true"
import script from "./SectionFeedback.vue?vue&type=script&lang=js"
export * from "./SectionFeedback.vue?vue&type=script&lang=js"

import "./SectionFeedback.vue?vue&type=style&index=0&id=6c79f25a&scoped=true&lang=css"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c79f25a"]])

export default __exports__